import TopTeam from 'components/base/top-team/TopTeam';

import React from 'react';

const LogisticsStatsPageThree = () => {
  return <TopTeam title='The top riders for the week...' />;
};
export default LogisticsStatsPageThree;
